import React, { forwardRef } from 'react';
import { useTheme, type SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { cs } from '@bbkAdminUtils/css-utils';
import { type EmotionTheme } from '@bbkFunnel/pages/theme';

const GridItemContainer = styled.div`
  height: 100%;
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  @media (max-width: 760px) {
    width: auto;
  }
`;

const GridItemInnerContainer = styled.div<{
  theme: EmotionTheme;
  isHorizontal: boolean;
  otherStyles?: SerializedStyles;
}>`
  height: 100%;
  ${({ isHorizontal }) =>
    isHorizontal
      ? ''
      : `
    padding: 30px;
    @media (max-width: 480px) {
      padding: 30px 15px;
    }
  `}
  background: ${({ theme }) => theme.cardBackground};
  border-radius: ${({ theme }) => theme.borderRadius}px;
  box-shadow: ${({ theme }) => theme.boxShadow};
  border: ${({ theme }) => theme.border};
  ${({ otherStyles }) => otherStyles ?? ''}
`;

type Props = {
  hasFullCardAction?: boolean;
  classes?: string;
  styles?: SerializedStyles;
  onClick?: () => void;
  children: React.ReactNode;
  isHorizontal?: boolean;
};
export const LossGridItem = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const {
    hasFullCardAction,
    isHorizontal,
    classes,
    styles,
    children,
    ...restProps
  } = props;
  const theme = useTheme() as EmotionTheme;

  return (
    <GridItemContainer className="bbk-loss-components-grid-item" ref={ref}>
      <GridItemInnerContainer
        className={cs({ 'tw-cursor-pointer': hasFullCardAction }, classes)}
        isHorizontal={isHorizontal ?? false}
        theme={theme}
        otherStyles={styles}
        {...restProps}
      >
        {children}
      </GridItemInnerContainer>
    </GridItemContainer>
  );
});
